import { WorkoutSet } from "../types";

const formatWorkoutsForSharing = (workouts: WorkoutSet[], selectedDate: string, t: any) => {
  let shareText = `${t('share.intro')}\n\n`;
  shareText += `${t('workout.workoutsFor')} ${selectedDate}:\n\n`;

  workouts.forEach(workout => {
    shareText += `${workout.exercise}:\n`;
    if (workout.workout_type === 'amrap') {
      shareText += `  - ${t('workout.amrapTime')}: ${workout.amrap_time_seconds} ${t('units.minutes')}\n`;
      workout.amrap_details?.forEach(detail => {
        shareText += `  - ${detail.reps} ${t('units.reps')}}\n`;
      });
    } else {
      workout.details.forEach(detail => {
        shareText += `  - ${detail.series} ${t('workout.series')} ${t('global.of')} ${detail.reps} ${t('units.reps')} ${t('global.with')} ${detail.weight} ${t('units.kg')}\n`;
      });
    }
    shareText += '\n';
  });

  shareText += `\n${t('share.outro')}`;

  return shareText;
};

export { formatWorkoutsForSharing };
